import isUrl from "validator/es/lib/isURL";

export const isSecureUrl = (value: string): boolean =>
  isUrl(value, { protocols: ["https"], require_protocol: true });
